export default __webpack_public_path__ + "static/media/breadcrumb-master-bg.b5bb957a.svg";